import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CopyrightCircleFilledSvg from "@ant-design/icons-svg/es/asn/CopyrightCircleFilled";
import AntdIcon from "../components/AntdIcon";
var CopyrightCircleFilled = function CopyrightCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyrightCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CopyrightCircleFilled.displayName = 'CopyrightCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(CopyrightCircleFilled);